import React, { useState, useEffect } from 'react';
import { Button, Dropdown, Layout, Menu, Space, Spin, Typography } from 'antd';
import { DownOutlined, MenuOutlined, CloseOutlined } from '@ant-design/icons';
import languageStore from '../../store/languageStore';
import { observer } from 'mobx-react-lite';
import './Header.css';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const { Header } = Layout;
const { Link } = Typography;

const CustomHeader = observer(() => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    languageStore.initialize();
  }, []);

  useEffect(() => {
    const fetchMenuItems = async () => {
      try {
        const response = await fetch('https://api2.praguecoolpass.com/menu');
        const data = await response.json();
        const filteredItems = data.filter(item => item.type === 'section');
        setMenuItems(filteredItems);
      } catch (error) {
        console.error('Error fetching menu items:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchMenuItems();
  }, []);

  const languageMenu = (
    <Menu onClick={({ key }) => languageStore.setLanguage(key)}>
      {languageStore.languages.map((lang) => (
        <Menu.Item key={lang.alpha2code}>{lang.title}</Menu.Item>
      ))}
    </Menu>
  );

  useEffect(() => {
    let lastScrollTop = 0;

    const handleScroll = () => {
      const scrollTop = window.scrollY;

      if (scrollTop > lastScrollTop && scrollTop > 100) {
        setIsScrolled(true);
      } else if (scrollTop < lastScrollTop) {
        setIsScrolled(false);
      }

      lastScrollTop = scrollTop;
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <Header
        className={isScrolled ? 'header header-scrolled' : 'header header-visible'}
        style={{
          flexDirection: 'row',
          display: 'flex',
          justifyContent: 'space-between',
          height: '5%',
          margin: 0,
        }}
      >
        <div className="desktop-menu">
          <div className="logo">CoolPass</div>

          <Menu
            style={{
              backgroundColor: 'transparent',
              color: 'white',
              height: '5%',
              alignItems: 'center',
            }}
            mode="horizontal"
            defaultSelectedKeys={['1']}
          >
            {loading ? (
              <Spin />
            ) : (
              menuItems.map((item, index) => (
                <Menu.Item key={index + 1}>
                  <Link
                    onClick={() => {
                      if (index + 1 === 2) {
                        navigate('/attractions');
                      } else {
                        navigate('/under-construction');
                      }
                    }}
                    className="header-item-text"
                  >
                    {item.content[languageStore.selectedLanguage].title}
                  </Link>
                </Menu.Item>
              ))
            )}
          </Menu>
          <Space>
            <Button
              onClick={() => {
                navigate('/under-construction');
              }}
              type="primary"
              className="custom-button"
            >
              {t('BUY_NOW')}
            </Button>
            {languageStore.loading ? (
              <Spin />
            ) : (
              <Dropdown overlay={languageMenu} trigger={['click']}>
                <Button
                  style={{
                    backgroundColor: '#252c3e',
                    color: 'white',
                    border: 'none',
                    width: '115px',
                    fontSize: '15px',
                    height: '35px',
                    display: 'flex',
                    alignItems: 'center',
                    alignSelf: 'center',
                    fontWeight: 600,
                  }}
                >
                  {languageStore.languages.find(
                    (lang) => lang.alpha2code === languageStore.selectedLanguage
                  )?.title || 'Select Language'}{' '}
                  <DownOutlined />
                </Button>
              </Dropdown>
            )}
          </Space>
        </div>
        <div className="mobile-menu">
          <div
            style={{
              justifyContent: 'space-between',
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
              alignItems: 'center',
              paddingLeft: 20,
              paddingRight: 20,
              backgroundColor:isMenuOpen?'#444959':'transparent'
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 20 }}>
              <Button
                style={{backgroundColor:'transparent', boxShadow:'none', color:'orange', fontSize:'22px'}}
                type="primary"
                icon={isMenuOpen ? <CloseOutlined style={{fontSize:'24px'}} color='orange'/> : <MenuOutlined style={{fontSize:'24px'}} size={24} color='orange'/>}
                onClick={toggleMenu}
              />
              <div className="logo">CoolPass</div>
            </div>
            {isMenuOpen?
              <Dropdown overlay={languageMenu} trigger={['click']}>
                <Button
                  style={{
                    backgroundColor: '#252c3e',
                    color: 'white',
                    border: 'none',
                    width: '115px',
                    fontSize: '15px',
                    height: '35px',
                    display: 'flex',
                    alignItems: 'center',
                    alignSelf: 'center',
                    fontWeight: 600,
                  }}
                >
                  {languageStore.languages.find(
                    (lang) => lang.alpha2code === languageStore.selectedLanguage
                  )?.title || 'Select Language'}{' '}
                  <DownOutlined />
                </Button>
              </Dropdown>
            :
              <Button
                onClick={() => {
                  navigate('/under-construction');
                }}
                type="primary"
                className="custom-button"
                style={{alignSelf:'center', justifyContent:'center', display:'flex'}}
              >
                {t('BUY_NOW')}
              </Button>
            }
            
          </div>

          {isMenuOpen && (
            <div
              className="dropdown-menu"
              style={{
                backgroundColor: '#727580',
                position: 'absolute',
                top: '0px',
                width: '100%',
                zIndex: 0,
                transition: 'max-height 0.3s ease-in-out',
                maxHeight: isMenuOpen ? '600px' : '0',
                overflow: 'hidden',
                alignItems:'center',
                justifyContent:'center',
                paddingTop:'64px',
                paddingBottom:'64px',
                height: '60vh',
                alignSelf:'center',
                display:'flex',
                flexDirection:'column'
              }}
            >
              <Menu mode="vertical" defaultSelectedKeys={['2']} className="dropdown-menu-list">
                {loading ? (
                  <Spin />
                ) : (
                  menuItems.map((item, index) => (
                    <Menu.Item style={{backgroundColor:'transparent'}} key={index + 1} onClick={toggleMenu}>
                      <Link
                        onClick={() => {
                          if (index + 1 === 2) {
                            navigate('/attractions');
                          } else {
                            navigate('/under-construction');
                          }
                        }}
                        className="header-item-text"
                      >
                        {item.content[languageStore.selectedLanguage].title}
                      </Link>
                    </Menu.Item>
                  ))
                )}
              </Menu>
              <Button
                  onClick={() => {
                    navigate('/under-construction');
                  }}
                  type="primary"
                  className="custom-button"
                  style={{alignSelf:'center', justifyContent:'center', display:'flex', width:'50%',}}
                >
                  {t('BUY_NOW')}
                </Button>
            </div>
          )}
        </div>
      </Header>
    </>
  );
});

export default CustomHeader;
